export const getCustomerViewType = (customer?: { ikeaFamilyNumber?: string; isBusinessCustomer?: boolean }) => {
    if (customer?.isBusinessCustomer) {
        return 'Business';
    }
    if (customer?.ikeaFamilyNumber) {
        return 'Family';
    }
    return 'Private';
};

export const findEntityMatchingViewType = <T extends { viewType?: string } | undefined>(
    entities: T[] | undefined,
    viewTypes: string[]
): T | undefined => {
    if (!entities) {
        return undefined;
    }

    return viewTypes.map((viewType) => entities.find((item) => item?.viewType === viewType)).find(Boolean);
};
